import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthLayout } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function AttivaAccount() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Le password non coincidono");
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password: pw });
      signIn(data.user);
      nav("/", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  if (!info)
    return (
      <AuthLayout title="Attiva il tuo account" subtitle={err ? "" : "Verifica del link in corso…"}>
        {err ? (
          <div className="space-y-4" data-testid="invite-invalid">
            <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">{err}</p>
            <Link to="/login" className="text-sm text-primary hover:underline">Vai al login</Link>
          </div>
        ) : <Loader2 className="h-5 w-5 animate-spin text-primary" />}
      </AuthLayout>
    );

  return (
    <AuthLayout title={`Benvenuto, ${info.name.split(" ")[0]}`} subtitle={`Scegli la password per accedere con ${info.email}.`}>
      <form onSubmit={submit} className="space-y-5" data-testid="invite-form">
        <div className="space-y-2"><Label>Password (min. 8 caratteri)</Label><Input type="password" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} required autoComplete="new-password" data-testid="invite-password-input" /></div>
        <div className="space-y-2"><Label>Conferma password</Label><Input type="password" minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} required autoComplete="new-password" data-testid="invite-password-confirm-input" /></div>
        {err && <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="invite-error">{err}</p>}
        <Button type="submit" className="w-full" disabled={busy} data-testid="invite-submit-button">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Attiva account
        </Button>
      </form>
    </AuthLayout>
  );
}
